import { ColorRecipeModel } from '../../models/color-recipe.model';
import { PaintBrushMode } from '../../models/paint-brush-mode.enum';

export class SetColorRecipe {
  static readonly type = '[Edit Paint] Set Color Recipe';
  constructor(public colorRecipe: ColorRecipeModel) { }
}

export class SetPaintBrushMode {
  static readonly type = '[Edit Paint] Set Paint Brush Mode';
  constructor(public brushMode: PaintBrushMode) { }
}

export class ClearColorRecipe {
  static readonly type = '[Edit Paint] Clear Color Recipe';
  constructor() { }
}

export class ResetPaint {
  static readonly type = '[Edit Paint] Reset Paint';
  constructor() { }
}
